import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { City } from '@core/models/city';
import { environment } from '@environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CityApi {
  private readonly http = inject(HttpClient);

  public getCities(): Observable<City[]> {
    const url = `${environment.apiHost}/administration/api/v1/cities`;

    return this.http.get<City[]>(url);
  }
}
